import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SponsoredContentService } from 'src/app/core/services/sponsored-content.service';
import { ArticleData, IdArticle } from 'src/app/models/sponsored-content';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-sponsored-content',
  templateUrl: './sponsored-content.component.html',
  styleUrls: ['./sponsored-content.component.css']
})
export class SponsoredContentComponent implements OnInit{
  formArticle!: FormGroup;
  articles: ArticleData[] = [];

  constructor(private fB:FormBuilder, private servSponsored: SponsoredContentService){

    this.formArticle = this.fB.group({
      url: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.loadSponsoredArticles();
  }

  loadSponsoredArticles() {
    this.servSponsored.getArticlesSponsored().subscribe({
      next: (response) => {
        const sponsorArticles = response.data.section.sponsorArticles;
        const flatArticles = sponsorArticles.flatMap(s => s.articles.map(a => a.data));
        this.articles = flatArticles;
        console.log('Artículos patrocinados:', this.articles);
      },
      error: (error) => {
        console.error('Error al cargar artículos patrocinados:', error);
      }
    })
  }


  addNewArticle(){
    Swal.fire({
      title: "¿Está seguro de agregar esta nota?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3C00A3",
      cancelButtonColor: "#D6E0FF",
      confirmButtonText: "Guardar",
      cancelButtonText: "Cancelar",
      customClass: {
        cancelButton: 'swal-cancel-text-color'
      }  

    }).then((result) => {
      if (result.isConfirmed) {
          this.sendArticles(); 
      }
    });
  }


  sendArticles(){
    const urlValue = this.formArticle.value.url.trim();

    if(!urlValue){
      Swal.fire({
        icon: 'warning',
        title: 'Ulr vacía',
        text: 'Es obligatorio agregar una url',
        confirmButtonColor: '#3C00A3'
      });
      return;
    }

    const payload = {url: urlValue};

    this.servSponsored.createArticle(payload).subscribe({
      next: (response) => {
        Swal.fire({
          icon: 'success',
          text: 'Artículo agregado con éxito',
          confirmButtonColor: '#3C00A3'
        }).then(() => {
          this.loadSponsoredArticles(); 
          this.formArticle.reset(); 
        });
      },
      error: (error) => {
        console.error('Error al crear artículo:', error);
      }
    })
  }

  removeArticleByArticleId(IdArticle: string){
    const payload: IdArticle = {id: IdArticle};
    
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Vas a eliminar este artículo.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3C00A3',
      cancelButtonColor: '#D6E0FF',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
      customClass: {
        cancelButton: 'swal-cancel-text-color'
      } 
    }).then((result) => {
      if (result.isConfirmed) {

        this.servSponsored.deleteArticle(payload).subscribe({
          next: (response) =>{
            console.log('Artículo eliminado', response);
            this.loadSponsoredArticles();
          },
          error: (error) => {
            console.error('Error al eliminar', error);
          }
        });
        
      }
    });

  }

}
